import * as React from 'react';
function IconSync(props) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconSync", ...props },
        React.createElement("path", { d: "M17.751 13.716l1.917.572a8.003 8.003 0 01-13.669 3.004L6 20H4v-6h6v2l-2.472.001a6.003 6.003 0 0010.224-2.285zM20 4v6h-6V8h2.473a6.003 6.003 0 00-10.23 2.302l-1.918-.564a8.003 8.003 0 0113.677-3.029L18 4h2z", fill: "currentColor" })));
}
export default IconSync;
//# sourceMappingURL=IconSync.js.map